// extracted by mini-css-extract-plugin
export default {"DureeRdv":"DureeRdv_DureeRdv__zt06Y"};